import React from 'react'
import "./industry.scss"
import ArtificialIntelligence from './sections/artificialIntelligence'
import EveryCent from './sections/everyCent'
import YourCompany from './sections/yourCompany'
import Letsgo from "../connectors/letsgo"

function Industry() {
  return (
    <div className='container-industry'>
        <div className="section-your-company">
            <YourCompany />
        </div>
        <div className="section-every-cent">
            <EveryCent />
        </div>
        <div className="section-artificial-intelligence">
            <ArtificialIntelligence />
        </div>
        <div className="section-letsgo">
            <Letsgo />
        </div>
    </div>
  )
}

export default Industry